import React, { useState, useEffect } from 'react';
import { StyledOnboarding, StyledOnboardingClose, StyledOnboardingContent } from './Onboarding.styles';
import { useCookie } from '../../hooks/useCookie';

const Onboarding = ({ children, id, className }) => {
    const [storedValue, setValue] = useCookie(`onboarding-${id}`, false);

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const handleClick = (e) => {
        e.preventDefault();
        setValue(true);
    };

    if (!isClient) {
        return null;
    }

    return !storedValue ? (
        <StyledOnboarding aria-label="Information om min lista" className={className}>
            <StyledOnboardingContent>{children}</StyledOnboardingContent>
            <StyledOnboardingClose role="button" aria-label="stäng meddelandet" onClick={handleClick} />
        </StyledOnboarding>
    ) : null;
};

export default Onboarding;
